import styled from "styled-components";
import { Layout, Button, Breadcrumb, Space } from "antd";
import { ReactComponent as BackButtonIcon } from "../../../../../../assets/icons/BackButton.svg";

export const StyledHeader = styled(Layout)`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledSpace = styled(Space)`
  display: flex;
  align-items: center;
`;

export const BackButton = styled(Button)`
  width: 2rem;
  height: 2rem;
  border: 0;
  outline: none;
  box-shadow: none;
  background-color: transparent;

  &:hover {
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
    box-shadow: none;
  }
`;

export const StyledBackButtonIcon = styled(BackButtonIcon)`
  width: 24px;
  height: 24px;
`;

export const Header = styled(Layout)`
  background-color: transparent;
  margin-bottom: 10px;
`;
